import { Container } from "react-bootstrap";
import { CardStats } from "../CardStats";

const OurStats = ({ data }) => {

  return (
    <div
      className="w-100"
      style={{
        backgroundColor: "rgba(255, 250, 238, 0.3)", 
        backgroundImage:
          "url('https://res.cloudinary.com/dr0lbokc5/image/upload/v1702146276/Group_37877_glv3ug.png')",
        backgroundSize: "cover",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
        padding: "40px 0px 80px 0px",
      }}
    >
      <Container className="d-flex justify-content-center">
        <div className="col-10 gap-5 row m-0">
          <h1 className="fw-bold" style={{ fontSize: "36px" }}>
            Our Stats
          </h1>
          <div className="d-flex w-100 justify-content-between">
            {data?.map((item, index) => {
              return <CardStats key={index} item={item} />;
            })}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OurStats;
